export function launchSupportBeacon(page) {
    window.Beacon("init", page.props.beaconId);
    window.Beacon("session-data", {
        "Team Name": "Guest",
    });
    window.Beacon("open");
}
